import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { cliengoQueries } from '@cliengo/mfe-utils/hooks';

import { setHubspotScript } from './bootstrap';
import { MainLayout } from './layouts/MainLayout';

import { logout } from '@/utils/auth';

export function Root() {
  const userQuery = cliengoQueries.user();

  useEffect(() => {
    setHubspotScript();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // el token no es valido
  if (userQuery.error && userQuery.error.message.includes('403')) {
    logout();
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
